import {Cell} from "react-table";
import moment from "moment";
import React from "react";

const toLocalTime = (date: string, format: string): string => {
    return moment
        .tz(date, 'Europe/Berlin')
        .format(format);
};

/**
 * Rendert eine allgemeine Datum-Tabellen-Zelle
 *
 * @param cell
 * @param key - Name im Datensatz
 * @param format - Datumsformat
 * @constructor
 */
const DateColumn: (cell: Cell, key: string, format?: string)
    => (JSX.Element | null) = (cell: Cell, key: string, format: string = 'DD.MM.YYYY HH:mm') => {

    if (cell.row.values[key]) {
        return (
            <span>{toLocalTime(cell.row.values[key], format)}</span>
        );
    }

    return null;
}

export default DateColumn;
